import { render, staticRenderFns } from "./PollEditor.vue?vue&type=template&id=04b274d4&scoped=true"
import script from "./PollEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PollEditor.vue?vue&type=style&index=0&id=04b274d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b274d4",
  null
  
)

export default component.exports